module.exports = __webpack_public_path__ + "fonts/Graphik-Medium.e160ec12.woff";